if (!customElements.get('promotion-carousel')) {
  class PromotionCarousel extends HTMLElement {
    constructor() {
      super();
      this.items = Array.from(this.querySelectorAll('.promotion__item'));
      this.index = 0;
      this.autoplay = this.hasAttribute('data-autoplay');
      this.pauseOnHover = this.hasAttribute('data-pause-on-hover');
      this.interval = (parseFloat(this.getAttribute('data-interval')) || 4) * 1000;
      this.timer = null;
    }

    connectedCallback() {
      if (!this.items.length) return;

      this.items.forEach((item, i) => item.classList.toggle('is-active', i === 0));

      if (this.items.length < 2) return;

      if (this.autoplay) this.start();

      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => {
          if (this.autoplay) this.start();
        });
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    start() {
      this.stop();
      this.timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    next() {
      this.items[this.index].classList.remove('is-active');
      this.index = (this.index + 1) % this.items.length;
      this.items[this.index].classList.add('is-active');
    }
  }

  customElements.define('promotion-carousel', PromotionCarousel);
}
